// ============================================================
//  LANDSCAPING CATEGORIES — 17 categories that group the ~190
//  services across Raza Pro's landscaping coverage. Each entry
//  is the navigator-level metadata only (id, label, icon, note).
//  The calculator config + materials + labor + templates for
//  each category live in /documents/categories/landscaping/<id>/
//  and will be loaded into a per-category bundle later.
// ============================================================

import {
  Pencil, Hammer, Trees, Sprout, Scissors, Layers, Droplets,
  Grid3x3, Box, Waves, Fence, Lightbulb, Flame, Snowflake,
  CalendarClock, Bug, Sparkles,
} from 'lucide-react';
import type { CategoryDef } from './registry';

export const LANDSCAPING_CATEGORIES: CategoryDef[] = [
  { id: 'design',       label: 'Design & Consultation',            icon: Pencil },
  { id: 'site-prep',    label: 'Site Prep & Demolition',           icon: Hammer },
  { id: 'tree-care',    label: 'Tree Care',                         icon: Trees,         note: 'ANSI A300, 10 sub-disciplines' },
  { id: 'planting',     label: 'Planting & Softscape',              icon: Sprout },
  { id: 'lawn-care',    label: 'Lawn Care & Turf',                  icon: Scissors,      note: 'Mowing, aeration, fertilization' },
  { id: 'mulch-beds',   label: 'Mulch & Beds',                      icon: Layers },
  { id: 'irrigation',   label: 'Irrigation & Water Management',     icon: Droplets },
  { id: 'hardscape',    label: 'Hardscape',                         icon: Grid3x3,       note: 'Pavers, walls, patios' },
  { id: 'concrete',     label: 'Concrete',                          icon: Box,           note: 'Light-format only' },
  { id: 'drainage',     label: 'Drainage & Grading',                icon: Waves },
  { id: 'structures',   label: 'Outdoor Structures',                icon: Fence,         note: 'Fence, deck, carpentry' },
  { id: 'lighting',     label: 'Outdoor Lighting',                  icon: Lightbulb },
  { id: 'water-fire',   label: 'Water & Fire Features',             icon: Flame },
  { id: 'snow-ice',     label: 'Snow & Ice Management',             icon: Snowflake },
  { id: 'seasonal',     label: 'Seasonal & Recurring Bundles',      icon: CalendarClock },
  { id: 'pest-control', label: 'Plant Health Care & Pest Control',  icon: Bug },
  { id: 'specialty',    label: 'Specialty / Niche',                 icon: Sparkles },
];

export const LANDSCAPING_CATEGORIES_BY_ID: Record<string, CategoryDef> =
  LANDSCAPING_CATEGORIES.reduce((acc, c) => { acc[c.id] = c; return acc; }, {} as Record<string, CategoryDef>);

// CATEGORIES_BY_TRADE moved to ./registry.ts (cross-trade index, no longer
// lives in any individual trade's file).
